<template>
  <div>
    <span :class="['Spinner', sizeClass]">
      <svg v-if="size === 'large'" viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.542 1.487A21.507 21.507 0 00.5 22c0 11.874 9.626 21.5 21.5 21.5 9.847 0 18.364-6.675 20.809-16.072a1.5 1.5 0 00-2.904-.756C37.803 34.755 30.473 40.5 22 40.5 11.783 40.5 3.5 32.217 3.5 22c0-8.137 5.3-15.247 12.942-17.65a1.5 1.5 0 10-.9-2.863z"
        />
      </svg>
      <svg v-else viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.229 1.173a9.25 9.25 0 1011.655 11.412 1.25 1.25 0 10-2.4-.698 6.75 6.75 0 11-8.506-8.329 1.25 1.25 0 10-.75-2.385z"
        />
      </svg>
    </span>
    <span v-bind="spanAttributes">
      <p-text v-if="shouldShowAccessibilityLabel" as="span" visually-hidden>
        {{ accessibilityLabel }}
      </p-text>
    </span>
  </div>
</template>

<script>
import PText from '@/components/polaris/PText.vue';

export default {
  name: 'Spinner',

  components: {
    PText,
  },

  props: {
    /**
     * Size of spinner
     * @default 'large'
     */
    size: {
      type: String,
      default: 'large',
      validator: value => ['small', 'large'].includes(value),
    },

    /** Accessible label for the spinner */
    accessibilityLabel: {
      type: String,
      default: undefined,
    },

    /** Allows the component to apply the correct accessibility roles based on focus */
    hasFocusableParent: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isAfterInitialMount: false,
    };
  },

  computed: {
    spanAttributes() {
      if (!this.hasFocusableParent) {
        return { role: 'status' };
      }
      return {};
    },

    sizeClass() {
      return 'size' + this.size[0].toUpperCase() + this.size.slice(1);
    },

    shouldShowAccessibilityLabel() {
      return (this.isAfterInitialMount || !this.hasFocusableParent) && this.accessibilityLabel;
    },
  },

  mounted() {
    this.isAfterInitialMount = true;
  },
};
</script>

<style scoped lang="scss">
$small-size: 20px;
$large-size: 44px;

@mixin spinnerSize($size) {
  height: $size;
  width: $size;
}

.Spinner svg {
  animation: var(--p-motion-keyframes-spin) var(--p-motion-duration-500) linear infinite;
  fill: var(--p-color-bg-fill-brand);
}

.sizeSmall svg {
  @include spinnerSize($small-size);
}

.sizeLarge svg {
  @include spinnerSize($large-size);
}
</style>
